import { render, staticRenderFns } from "./RedeemPointsPopup.vue?vue&type=template&id=1863139a&scoped=true&"
import script from "./RedeemPointsPopup.vue?vue&type=script&lang=js&"
export * from "./RedeemPointsPopup.vue?vue&type=script&lang=js&"
import style0 from "./RedeemPointsPopup.vue?vue&type=style&index=0&id=1863139a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863139a",
  null
  
)

export default component.exports